import { styled } from '@mui/material/styles';
import { COLOR } from '@src/styles/color';

export const StyledSubscriptionNew = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: ${COLOR.white};
  margin-top: 16px;
  border-radius: 16px;
  flex: 1;
  align-items: center;
  min-height: calc(100vh - 40px);
  .container {
    max-width: 1200px;
    box-sizing: border-box;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  .btn-action {
    display: flex;
    gap: 8px;
  }
  @media (max-width: 768px) {
    margin-top: 8px;
    min-height: 100%;
    background-color: transparent;
    gap: 16px;
    .header-container {
      flex-direction: column;
      gap: 16px;
      border-bottom: none !important;
      padding: 0 !important;
    }
    .btn-action {
      gap: 10px;
    }
    .buy-more-btn {
      width: 166.5px;
    }
  }
  .buy-more-btn {
    height: 40px;
  }

  .header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 24px 40px;
    border-bottom: 1px solid ${COLOR.label[16]};

    .title {
      font-size: 20px;
      font-weight: 700;
      line-height: 28px;
      color: ${COLOR.darkGray};
      letter-spacing: -0.4px;
    }

    @media (max-width: 768px) {
      padding: 16px;
    }
  }

  .notification-container {
    padding: 24px 40px 0 40px;
    box-sizing: border-box;
    width: 100%;

    @media (max-width: 768px) {
      padding: 0 16px;
    }
  }

  .packages-container {
    display: flex;
    gap: 16px;
    padding: 24px 40px;
    flex-wrap: wrap;

    @media (max-width: 768px) {
      flex-direction: column;
      padding: 16px;
      gap: 12px;
      padding: 0 !important;
      justify-content: center;
    }
  }
`;
